// extracted by mini-css-extract-plugin
export var modal = "_u4-0";
export var table = "_u4-1";